import { ErrorMessage, Field, FormikProps } from 'formik';
import { withFormikValidation } from './enhancer/AddEditStagesEnhancer';
import { Box, Button, Checkbox, Label, useColorMode } from 'theme-ui';
import theme from '../../../../theme';

import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getStageDataById } from '../../../../store/actions/masterData.action';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../@types';
import { ActionCreateByUrl, ActionUpdateById } from '../../../../store/actions/CommonAction';


const AddEditStages: React.FC<FormikProps<any>> = ({
    values,
    errors,
    touched,
    handleSubmit,
    setValues,
    validateForm,
    setFieldValue,
    isValid,
    isSubmitting,
    submitCount
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { stageId } = useParams();
    const { individualStage } = useSelector((state: RootState) => state?.masterData);
    const [isNeedToValidate, setIsNeedToValidate] = useState<boolean>(false);
    const [colorMode] = useColorMode();

    // console.log(individualStage, "check31");

    useEffect((): void => {
        if (stageId) {
            dispatch(getStageDataById({ id: stageId }))
        }
    }, [stageId])
    useEffect(() => {
        if (stageId && individualStage?.status) {
            setValues({
                ...values,
                name: individualStage?.data?.name,
                color: individualStage?.data?.color,
                description: individualStage?.data?.description,
                isIPR: individualStage?.data?.isIPR || false,
                isMEP: individualStage?.data?.isMEP || false,
                isStructural: individualStage?.data?.isStructural || false,
                isFireSprinkler: individualStage?.data?.isFireSprinkler || false,
            })
            setIsNeedToValidate(true);
        }
    }, [individualStage?.data])
    useEffect(() => {
        if (isNeedToValidate) {
            validateForm();
        }
    }, [isNeedToValidate])
    const handleArchitectData = async (): Promise<void> => {
        handleSubmit();
        if (isValid) {
            stageId ?
                dispatch(ActionUpdateById({ Query: `stages/edit-stage/${stageId}`, obj: values }, (res: any) => {
                    if (res.status) {
                        navigate("/stages")
                    }
                }))
                :
                dispatch(ActionCreateByUrl({ Query: "stages/create-stages", obj: values }, (res: any) => {
                    if (res.status) {
                        navigate("/stages")
                    }
                }));
        }
    }
    return (
        <div className="main-content p-5">
            <h1 style={{ color: colorMode === "light" ? "black" : "white" }}>{stageId ? "Edit" : "Add"} Stage</h1>
            <div className="row">
                <div className="col-md-4 mt-4">
                    <Label htmlFor="name" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.name && touched.name ? 'is-invalid' : ''}`}>First Name<span className="text-danger">*</span></Label>
                    <Field type="text" id="name" name="name" className="form-control" placeholder="Stage Name" />
                    <ErrorMessage name="name" component="div" className="text-danger" />
                </div>
                <div className="col-md-4 mt-3">
                    <label htmlFor="description" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.description && touched.description ? 'is-invalid' : ''}`}>Description<span className="text-danger">*</span></label>
                    <Field type="text" id="description" name="description" className="form-control" placeholder="Stage Description" />
                    <ErrorMessage name="description" component="div" className="text-danger" />
                </div>
                <div className="col-md-4 mt-3">
                    <label htmlFor="color" style={{ color: colorMode === "light" ? "black" : "white" }} className={`form-label mt-1 ${errors.color && touched.color ? 'is-invalid' : ''}`}>Color<span className="text-danger">*</span></label>
                    <Box className="text-center d-flex">
                        <Field type="color" id="color" name="color" className="form-control" placeholder="Stage color" />
                    </Box>
                    <ErrorMessage name="color" component="div" className="text-danger" />
                </div>
                <div className="col-md-12 mt-3 d-flex gap-4 flex-wrap">
                    <div>
                        <Label
                            sx={{ color: colorMode === "light" ? "black" : "white" }}
                            htmlFor="isIPR"
                            className={`form-label mt-1 ${errors.isIPR && touched.isIPR ? 'is-invalid' : ''
                                }`}
                            style={{ color: colorMode === "light" ? "black" : "white" }}
                        >
                            IPR
                            <Checkbox
                                name="isIPR"
                                id="isIPR"
                                checked={values.isIPR}
                                disabled={(values.name === 'Prelim' || values.name === 'Full') && values.isIPR}
                                onChange={(e) => {
                                    if ((values.name === 'Prelim' || values.name === 'Full') && values.isIPR && !e.target.checked) return;
                                    setFieldValue('isIPR', e.target.checked);
                                }}
                            />
                        </Label>
                        <ErrorMessage name="isIPR" component="div" className="text-danger" />
                    </div>
                    <div>
                        <Label
                            sx={{ color: colorMode === "light" ? "black" : "white" }}
                            htmlFor="isMEP"
                            className={`form-label mt-1 ${errors.isMEP && touched.isMEP ? 'is-invalid' : ''
                                }`}
                            style={{ color: colorMode === "light" ? "black" : "white" }}
                        >
                            MEP
                            <Checkbox
                                name="isMEP"
                                id="isMEP"
                                checked={values?.isMEP}
                                disabled={(values.name === 'Prelim' || values.name === 'Full') && values.isMEP}
                                onChange={(e) => {
                                    if ((values.name === 'Prelim' || values.name === 'Full') && values.isMEP && !e.target.checked) return;
                                    setFieldValue('isMEP', e.target.checked);
                                }}
                            />
                        </Label>
                    </div>
                    <div>
                        <Label
                            sx={{ color: colorMode === "light" ? "black" : "white" }}
                            htmlFor="isStructural"
                            className={`form-label mt-1 ${errors.isStructural && touched.isStructural ? 'is-invalid' : ''
                                }`}
                            style={{ color: colorMode === "light" ? "black" : "white" }}
                        >
                            Structural
                            <Checkbox
                                name="isStructural"
                                id="isStructural"
                                checked={values?.isStructural}
                                onChange={(e) => {
                                    setFieldValue('isStructural', e.target.checked);
                                }}
                            />
                        </Label>
                    </div>
                    <div>
                        <Label
                            sx={{ color: colorMode === "light" ? "black" : "white" }}
                            htmlFor="isFireSprinkler"
                            className={`form-label mt-1 ${errors.isFireSprinkler && touched.isFireSprinkler ? 'is-invalid' : ''
                                }`}
                            style={{ color: colorMode === "light" ? "black" : "white" }}
                        >
                            Fire-protection
                            <Checkbox
                                name="isFireSprinkler"
                                id="isFireSprinkler"
                                checked={values?.isFireSprinkler}
                                onChange={(e) => {
                                    setFieldValue('isFireSprinkler', e.target.checked);
                                }}
                            />
                        </Label>
                    </div>
                </div>
                {errors.stageType && submitCount > 0 && <div className="col-md-12 text-danger mt-2">{errors.stageType as string}</div>}
            </div>
            <div className='row mt-5'>
                <div className='col-md-4'></div>
                <div className='col-md-4'><Button type="reset" sx={{ border: `1px solid ${theme.colors?.primary || 'defaultBorderColor'}`, background: 'white', color: theme.colors?.muted, borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} onClick={() => navigate(-1)}> Cancel </Button></div>
                <div className='col-md-4'><Button sx={{ borderRadius: '12px', padding: [2, 4, 2, 4], width: '95%' }} type='submit' onClick={handleArchitectData} disabled={isSubmitting}>Submit</Button></div>
            </div>
        </div >
    );
}

export default withFormikValidation(AddEditStages);